import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faLinkedin, faGithub, faHackerrank } from "@fortawesome/free-brands-svg-icons";
import { Link } from 'react-scroll';

const Footer = () => {
    return (
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-2 col-sm-6">
                        <div className="row">
                            <div className="col">
                                <Link smooth={true} to="home" className="footer-nav">Home</Link><br />
                                <Link smooth={true} to="aboutme" className="footer-nav">Aboutme</Link><br />
                                <Link smooth={true} to="services" className="footer-nav">Services</Link><br />
                            </div>
                            <div className="col">
                                <Link smooth={true} to="projects" className="footer-nav">Projects</Link><br />
                                <Link smooth={true} to="certificate" className="footer-nav">Certificates</Link><br />
                                <Link smooth={true} to="contacts" className="footer-nav">Contact</Link><br />
                            </div>
                        </div>
                    </div>

                    <div className="foicon">

                        <ul>

                            <li><a class="social-lsit__item" href="https://github.com/uvyuva" target="_blank">
                                <FontAwesomeIcon className="icon" icon={faGithub} size="2x" />
                            </a></li>


                            <li><a class="social-list__item" href="https://www.linkedin.com/in/yuvaraj-p-b744881aa/"
                                target="_blank"><FontAwesomeIcon className="icon" icon={faLinkedin} size="2x" /></a></li>


                            <li><a class="social-list__item" href="https://www.instagram.com/y_uva__uv/" target="_blank">
                                <FontAwesomeIcon className="icon" icon={faInstagram} size="2x" /></a></li>


                            <li><a class="social-list__item" href="https://www.hackerrank.com/yuvauv06" target="_blank">
                                <FontAwesomeIcon className="icon" icon={faHackerrank} size="2x" /></a></li>
                       
                        </ul>
                    </div>


                    <p className="pt-3 text-center">
                        Copyright&copy;
                        {new Date().getFullYear()}&nbsp; Yuvaraj (All rights reserved)
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer
